/* eslint-disable */
import { produce } from "immer";
import {
  MEMBER_DETAILS_FETCH_START,
  MEMBER_DETAILS_FETCH_SUCCESS,
  MEMBER_DETAILS_FETCH_FAILURE,
} from "../actions/types";

const memberDetails = (
  state = {
    memberDetailsFetching: false,
    memberDetailsData: [],
    memberDetailsError: null,
  },
  action,
) => {
  switch (action.type) {
    case MEMBER_DETAILS_FETCH_START:
      return produce(state, (draft) => {
        draft.memberDetailsFetching = true;
      });
    case MEMBER_DETAILS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.memberDetailsFetching = true;
        draft.memberDetailsData = action.data;
        draft.memberDetailsFetching = false;
      });
    case MEMBER_DETAILS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.memberDetailsFetching = false;
        draft.memberDetailsError = action.error;
      });
    default:
      return state;
  }
};

export default memberDetails;
